module.exports = __webpack_public_path__ + "static/media/fawry.62dec562.svg";